import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  templateUrl: './avionte-error-page.component.html',
  styleUrls: ['./avionte-error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-error-avionte',
})
export class AvionteErrorPageComponent {}
